var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://flk.npc.gov.cn/","width":"100%","height":"850"}})
}
var staticRenderFns = []

export { render, staticRenderFns }